import {combineReducers} from 'redux';
import MeAction, {reducer as MeUserReducer, MeUserTypes} from './me/MeUserRedux';
import SpecificAction, {reducer as SpecificUserReducer, SpecificUserTypes} from './specific/SpecificUserRedux';
import AllAction, {reducer as AllUserReducer, AllUserTypes} from './all/AllUserRedux';
import createAction, {reducer as CreateUserReducer, createUserTypes} from './create/createUserRedux';
import ProfileAction, {reducer as ProfileReducer, ProfileUserTypes} from './profile/ProfileUserRedux';

export default combineReducers({
    me: MeUserReducer,
    all: AllUserReducer,
    specific: SpecificUserReducer,
    create: CreateUserReducer,
    profileInfo: ProfileReducer,
});

export const UserTypes = {
    ...MeUserTypes, ...SpecificUserTypes,
    ...AllUserTypes, ...createUserTypes,
    ...ProfileUserTypes, 
};

export const UserActions = {
    ...MeAction, ...SpecificAction,
    ...AllAction, ...createAction,
    ...ProfileAction, 
};